import React, { Fragment } from "react";
import ReactFullscreen from "react-full-screen";
import FadeIn from "react-fade-in";
import medial1 from "assets/medals/medaille1.png";
import medial2 from "assets/medals/medaille2.png";
import medial3 from "assets/medals/medaille3.png";
import { translate } from "utlis/translations/i18n";

class ResourceResume extends React.Component {
  constructor() {
    super();
    this.state = { loaded: false, fullScreen: false };
  }

  render() {
    const { result, rank, maximum } = this.props;
    const { resource, points } = result;

    return (
      <Fragment>
        {this.state.loaded ? null : (
          <div
            style={{
              height: "200vh",
              width: "400px",
            }}
          />
        )}
        <div
          className="col-xs-12 col-sm-6 col-lg-4"
          style={this.state.loaded ? {} : { display: "none" }}
        >
          <FadeIn>
            <div className="row pair-comparison-resume">
              <div className="col-xs-12 col-md-12 col-lg-12 no-p-l-r resource">
                <div className="resource">
                  {resource.type !== "VIDEO" && (
                    <ReactFullscreen enabled={this.state.fullScreen}>
                      <span className="helper-img"></span>
                      <img
                        className="img-responsive cursor-pointer img-center"
                        alt="Resource (Pair comparaison)"
                        src={resource.downloadURL}
                        onClick={() =>
                          this.setState({ fullScreen: !this.state.fullScreen })
                        }
                        onLoad={() => this.setState({ loaded: true })}
                      />
                    </ReactFullscreen>
                  )}
                  {resource.type === "VIDEO" && (
                    <video
                      className="img-responsive"
                      alt="Resource (Pair comparaison)"
                      src={resource.downloadURL}
                      controls
                      muted
                    />
                  )}
                </div>
              </div>
              <div className="col-xs-12 col-md-12 col-lg-12 infos">
                <div className="row">
                  <div className="col-xs-12 col-md-6 col-lg-6">
                    <div className="metadata">
                      <div className="label">{translate('results.name')}</div>
                      <div className="value">{resource.name}</div>
                    </div>
                    <div className="metadata">
                      <div className="label">{translate('results.points')}*</div>
                      <div className="value">{points}</div>
                    </div>
                  </div>
                  <div className="col-xs-12 col-md-6 col-lg-6">
                    <div className="right-result-info-and-medal">
                      <div>
                        <div className="metadata">
                          <div className="label">{translate('results.position')}</div>
                          <div className="value">{rank}</div>
                        </div>
                        <div className="metadata">
                          <div className="label">{translate('results.score')}**</div>
                          <div className="value">
                            {(points / maximum).toFixed(2)}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 medal-container">
                        {rank === 1 && (
                          <img
                            src={medial1}
                            alt="winner 1"
                            className="medal-icon"
                          />
                        )}
                        {rank === 2 && (
                          <img
                            src={medial2}
                            alt="winner 2"
                            className="medal-icon"
                          />
                        )}
                        {rank === 3 && (
                          <img
                            src={medial3}
                            alt="winner 3"
                            className="medal-icon"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </Fragment>
    );
  }
}

export default ResourceResume;
